import React, { Component } from "react";
import styles from "./cmsReprocessUnits.module.scss";
import { withReprocessUnits } from "../../../shared/containers/containerReprocessUnits";
import { DataGrid } from "@mui/x-data-grid";
import getDates from "../../../shared/services/date.service";
import clsx from "clsx";
import "./cellTable.css";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../Contents/ModalComponents/DeleteConfirm";
import { states } from "../../../reducers/queriesStates";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";

class CmsReprocessUnits extends Component {
  constructor(props) {
    super(props);

    this.state = { selectedReprocessUnit: null, isDeleteModalOpen: false };
  }

  componentDidMount() {
    const { reprocessTypesDataState, onGetReprocessTypes } = this.props;

    if (reprocessTypesDataState === states.NOT_REQUESTED) {
      onGetReprocessTypes();
    }
  }

  componentDidUpdate(preProps) {
    const { deleteReprocessUnitsDataState } = this.props;

    if (preProps.deleteReprocessUnitsDataState === states.REQUEST && deleteReprocessUnitsDataState === states.READY) {
      this.setState({ selectedReprocessUnit: null, isDeleteModalOpen: false });
    }
  }

  getRows() {
    const rows = [];

    const { reprocessUnits, reprocessTypes } = this.props;

    const reprocessStatuses = {
      0: "В ожидании",
      1: "В ожидании завершения текущих процессов",
      2: "Подготовка",
      3: "В процессе",
      4: "Завершён",
      5: "Ошибка",
      6: "Обработчик не найден",
    };

    reprocessUnits.forEach((element) => {
      rows.push({
        ...element,
        ...element.unitInfo,
        reprocessType: reprocessTypes[element.reprocessType],
        reprocessStatus: reprocessStatuses[element.reprocessStatus],
        status: element.reprocessStatus,
        startDate: getDates.getDateFormat3(new Date(Date.parse(element.startDate + "Z"))),
        endDate: element.endDate !== null ? getDates.getDateFormat3(new Date(Date.parse(element.endDate + "Z"))) : null,
        startProcessDate:
          element.reprocessStatus !== 0 ? getDates.getDateFormat3(new Date(Date.parse(element.startProcessDate + "Z"))) : null,
      });
    });

    return rows;
  }

  getColumns() {
    const styleGuarantee = (params) => {
      return clsx("inActive-cell", {
        inActiveNegative: params.row.status > 4,
      });
    };

    const renderTitleCell = (params) => {
      return (
        <a href={`/cms/companies/${params.row.companyId}`} target="_blank" rel="noreferrer">
          {params.row.companyTitle}
        </a>
      );
    };

    return [
      {
        field: "unitTitle",
        headerName: "ТС",
        width: 150,
      },
      {
        field: "regisrerNumber",
        headerName: "Регистрационный номер",
        width: 150,
      },
      {
        field: "reprocessType",
        headerName: "Тип обработки",
        width: 200,
      },
      {
        field: "comment",
        headerName: "Комментарий",
        width: 350,
      },
      {
        field: "startDate",
        headerName: "Время точки начала обработки",
        width: 200,
      },
      {
        field: "endDate",
        headerName: "Время точки конца обработки",
        width: 200,
      },
      {
        field: "startProcessDate",
        headerName: "Смена статуса",
        width: 200,
      },
      {
        field: "reprocessStatus",
        headerName: "Статус обработки",
        cellClassName: styleGuarantee,
        width: 160,
      },
      {
        field: "companyTitle",
        renderCell: renderTitleCell,
        headerName: "Компания",
        width: 250,
      },
      {
        field: "ownershipAreaTitle",
        headerName: "Область владения",
        width: 150,
      },
    ];
  }

  onSelectHandler(e) {
    const { reprocessUnits } = this.props;
    const id = e[0];

    this.setState({
      selectedReprocessUnit: reprocessUnits.filter((x) => {
        return x.id === id;
      })[0],
      isDeleteModalOpen: false,
    });
  }

  onDeleteHandler() {
    const { onDeleteReprocessUnit } = this.props;
    const { selectedReprocessUnit } = this.state;

    onDeleteReprocessUnit(selectedReprocessUnit);
  }

  render() {
    const { reprocessUnits, lastSchedulerTime, reprocessTypesDataState } = this.props;
    const { selectedReprocessUnit = null, isDeleteModalOpen } = this.state;

    if (reprocessTypesDataState !== states.READY) {
      return null;
    }

    return (
      <div className={styles.cmsReprocessUnitsContainer}>
        <div className={styles.cmsReprocesslastSchedulerTime}>
          Последнее время сработки таймера: {getDates.getDateFormat3(lastSchedulerTime)}
        </div>
        <div className={styles.cmsReprocessSelectUnitContainer}>
          <div>{selectedReprocessUnit !== null ? selectedReprocessUnit.unitInfo.unitTitle : null}</div>
          <div>{selectedReprocessUnit !== null ? selectedReprocessUnit.unitInfo.regisrerNumber : null}</div>
          <div>
            {selectedReprocessUnit !== null ? (
              <ButtonPrimary
                disable={selectedReprocessUnit.reprocessStatus === 1}
                title={"Удалить"}
                handleClick={() => {
                  this.setState({ isDeleteModalOpen: true });
                }}
              />
            ) : null}
          </div>

          <div>
            {selectedReprocessUnit !== null && isDeleteModalOpen ? (
              <ModalConfirmWindow isOpen={isDeleteModalOpen}>
                <DeleteConfirm
                  onConfirmHandle={this.onDeleteHandler.bind(this)}
                  onNotConfirmHandle={(e) => {
                    this.setState({ isDeleteModalOpen: false });
                  }}
                  text={`Удалить повторную обработку ${selectedReprocessUnit.unitInfo.unitTitle} ${selectedReprocessUnit.unitInfo.regisrerNumber}?`}
                />
              </ModalConfirmWindow>
            ) : null}
          </div>
        </div>
        {reprocessUnits.length > 0 ? (
          <DataGrid
            rowHeight={30}
            ref={"DataGrid"}
            localeText={{
              ...dateGridLocalTextOptions,
              footerRowSelected: (count) => `Транспортных средств выбранно: ${count}`,
            }}
            rows={this.getRows()}
            columns={this.getColumns()}
            onRowSelectionModelChange={this.onSelectHandler.bind(this)}
          />
        ) : null}
      </div>
    );
  }
}

export default withReprocessUnits(React.memo(CmsReprocessUnits));
